import React from "react";
import LegalPage from "../components/LegalPage";

export default function Eula() {
  return (
    <LegalPage title="End-User License Agreement (EULA)">
      <section className="space-y-4">
        <p>
          Please read this End-User License Agreement ("Agreement") carefully
          before downloading or playing Kepithor Applications ("Application").
        </p>

        <p>
          By downloading or using the Application, you are agreeing to be bound
          by the terms and conditions of this Agreement.
        </p>

        <p>
          If you do not agree to the terms of this Agreement, do not download or
          use the Application.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">License</h2>
        <p>
          Kepithor Studios grants you a revocable, non-exclusive, non-transferable,
          limited license to download, install and use the Application solely for
          your personal, non-commercial purposes strictly in accordance with the
          terms of this Agreement.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Restrictions</h2>
        <p>You agree not to, and you will not permit others to:</p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>
            License, sell, rent, lease, assign, distribute, transmit, host,
            outsource, disclose or otherwise commercially exploit the Application
            or make the Application available to any third party.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Modifications to Application</h2>
        <p>
          Kepithor Studios reserves the right to modify, suspend or discontinue,
          temporarily or permanently, the Application or any service to which it
          connects, with or without notice and without liability to you.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Exploitation</h2>
        <p>
          Taking advantage of any possible exploit rather than reporting such a
          bug to Kepithor Studios is strictly prohibited and a breach of these terms.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Automation of Play</h2>
        <p>
          Automating play by any means is strictly prohibited and a breach of these terms.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Multiple Accounts</h2>
        <p>
          Creating multiple accounts or operating multiple accounts at the same time
          is strictly prohibited and a breach of these terms.
        </p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>Accounts flagged as multi-accounting will have 4 weeks to complete KYC.</li>
          <li>
            If not completed within that time the account will be closed and any KKT
            added to the following season&apos;s prize pool.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Friend Groups</h2>
        <p>
          We welcome and encourage friends to enjoy our games together. However, each
          player must operate their own account independently:
        </p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>All item trades must be conducted through NFT marketplaces (such as NFT.io).</li>
          <li>Transferring assets directly between accounts is strictly prohibited.</li>
          <li>Any users found violating these rules may be flagged for multi-accounting.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Inactive Email Addresses</h2>
        <p>
          Accounts made with inactive email addresses may be deleted and any associated
          assets forfeited.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Withdrawals</h2>
        <p>
          Kepithor Studios reserves the right to deny withdrawal features for you if
          Kepithor Studios believes you are breaching any of these terms. Any assets you
          have on account are thus account bound and virtual only.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Account Banning</h2>
        <p>
          Kepithor Studios reserves the right to ban players and/or deny features to
          anyone breaching any of these terms. You understand that breaching these terms
          may result in your assets being made account bound.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Inappropriate Player Names</h2>
        <p>
          Kepithor Studios reserves the right to change the username of any account with
          an inappropriate username. Inappropriate usernames include usernames which are:
        </p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>Obscene/racist.</li>
          <li>Advertising other products/services.</li>
          <li>Exposing real-life contact details.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Competitions</h2>
        <p>
          Kepithor Studios frequently holds promotional competitions and reserves the
          right to cancel them at any time Kepithor Studios deems necessary. Players that
          competed in cancelled competitions are not entitled to compensation, however
          Kepithor Studios may choose to provide compensation at their discretion.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Term and Termination</h2>
        <p>
          This Agreement shall remain in effect until terminated by you or Kepithor Studios.
        </p>
        <ul className="list-disc pl-5 space-y-2 mt-3">
          <li>
            Kepithor Studios may, in its sole discretion, at any time and for any or no
            reason, suspend or terminate this Agreement with or without prior notice.
          </li>
          <li>
            This Agreement will terminate immediately, without prior notice from Kepithor
            Studios, in the event that you fail to comply with any provision of this Agreement.
          </li>
          <li>
            You may terminate this Agreement by deleting the Application and all copies thereof
            from your mobile device or from your desktop.
          </li>
          <li>
            Upon termination of this Agreement, you shall cease all use of the Application and
            delete all copies of the Application from your mobile device or from your desktop.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Severability</h2>
        <p>
          If any provision of this Agreement is held to be unenforceable or invalid, such
          provision will be changed and interpreted to accomplish the objectives of such
          provision to the greatest extent possible under applicable law and the remaining
          provisions will continue in full force and effect.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Amendments to this Agreement</h2>
        <p>
          Kepithor Studios reserves the right, at its sole discretion, to modify or replace
          this Agreement at any time and do not need to provide prior notice to any new terms
          taking effect.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">Contact Information</h2>
        <p>
          If you have any questions about this Agreement, please contact us at{" "}
          <a
            href="mailto:team@kepithorstudios.com"
            className="text-emerald-400 hover:text-emerald-300 underline"
          >
            team@kepithorstudios.com
          </a>
          .
        </p>
      </section>
    </LegalPage>
  );
}